import React from 'react';
import styled from 'styled-components';

interface IEmailNewICon {}

const EmailNewIcon: React.FC<IEmailNewICon> = () => {
  return (
    <EmailNewIconStyle>
      {/* Changed width from 30 to 25 on svg. Component only used in fritid.tsx */}
      <svg
        width="25"
        height="19"
        viewBox="0 0 30 19"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M28 0H2C0.89543 0 0 0.89543 0 2V17C0 18.1046 0.89543 19 2 19H28C29.1046 19 30 18.1046 30 17V2C30 0.89543 29.1046 0 28 0Z"
          fill="#E7CFA7"
        />
        <path
          d="M3 3L10.6364 10M10.6364 10L13.6486 12.7612C14.2902 13.3493 14.611 13.6434 15 13.6434C15.389 13.6434 15.7098 13.3493 16.3514 12.7612L19.3636 10M10.6364 10L3 17M27 3L19.3636 10M19.3636 10L27 17"
          stroke="black"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </EmailNewIconStyle>
  );
};
const EmailNewIconStyle = styled.div`
  margin-top: -3px;
  padding-left: 15px;
`;
export default EmailNewIcon;
